export { default } from './WindArrow';
